import render from 'preact-render-to-string';
import { Link } from 'preact-router';
import { useState } from 'preact/hooks';
import Table from "../components/ui/Table";
import Select from '../components/ui/Select';
import SelectAuto from '../components/ui/SelectAuto';
import useApp from '../context/AppContext';

export default function WhoWhereWhen() {
    const { animals, locations, events } = useApp();
    const columns = [
        { label: "Animal", accessor: "animalName", sortable: false },
        { label: "Terrain", accessor: "locationName", sortable: false },
        { label: "Date arrivée", accessor: "dateStart", sortable: false },
        { label: "Date sortie", accessor: "dateEnd", sortable: false },
    ];
    const [result, setResult] = useState([]);
    const [animalNameFilter, setAnimalNameFilter] = useState("");
    const [animalList, setAnimalList] = useState([]);
    const [resultCounter, setResultCounter] = useState(0);

    if (!animals || !locations || !events) return;

    function cellFormat(value, accessor, data) {
        let str = value;
        switch (accessor) {
            case 'animalName':
                str = render(<Link href={'/animal/' + data.animalId}>{data.animalName}</Link>);
                break;
            case 'locationName':
                str = render(<Link href={'/location/' + data.locationId}>{data.locationName}</Link>);
                break;
            case 'dateStart':
                if (value && value != '——') {
                    str = new Date(value).toLocaleDateString();
                }
                break;
            case 'dateEnd':
                if (value && value != '——') {
                    if (new Date(value).toLocaleDateString() == new Date().toLocaleDateString())
                        str = "---";
                    else
                        str = new Date(value).toLocaleDateString();
                }
                break;
            default:
                break;
        }
        return str;
    }

    const handleAnimalFilterInSelect = (e) => {
        const value = e.target.value;
        setAnimalNameFilter(e.target.value);
        const animalListFiltered = animals.filter((animal) => {
            const animalName = animal.name.substring(0, value.length);
            return value.toLowerCase() == animalName.toLowerCase()
        })
        if (typeof animalListFiltered != "undefined") {
            setAnimalList(animalListFiltered);
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        e.returnValue = '';
        const fields = e.target;
        const result = [];
        let resultCounter = 0;
        let movements = events.filter(evt => parseInt(evt.type) === 1);
        let searchedDate = false;
        let searchedLocation = false;
        let prev = [];
        if (fields.date.value != "") {
            searchedDate = new Date(fields.date.value);
        }
        if (fields.location.value != "") {
            searchedLocation = fields.location.value;
        }
        if (fields.animal.value != "") {
            movements = movements.filter(evt => parseInt(fields.animal.value) == parseInt(evt.animalId));
        }
        movements.forEach(evt => {
            let d2;
            let d1 = new Date(evt.dateApi);
            if (!prev[evt.animalId]) {
                // if it's the first time we found this animal, end date is now for the current location
                d2 = new Date();
                prev[evt.animalId] = [];
            } else {
                d2 = new Date(prev[evt.animalId][prev[evt.animalId].length - 1].dateApi);
            }
            if (((searchedDate && searchedDate >= d1 && searchedDate <= d2) || !searchedDate)
                && ((searchedLocation && searchedLocation == evt.locationId) || !searchedLocation)) {
                if (result.length < 200) {
                    result.push({
                        animalId: evt.animalId,
                        animalName: evt.animalName,
                        locationId: evt.locationId,
                        locationName: evt.locationName,
                        dateStart: d1,
                        dateEnd: d2
                    });
                }
                resultCounter++;
            }
            prev[evt.animalId].push(evt);
        })
        if (result.length < resultCounter) {
            result.push({
                animalId: 0,
                animalName: "...",
                locationId: 0,
                locationName: "(Résultats tronqués à 200)",
                dateStart: "——",
                dateEnd: "——"
            });
        }
        setResultCounter(resultCounter);
        setResult(result);
    }

    return (
        <>
            <form onSubmit={handleSubmit}>
                <div class="row ms-1 me-1 pt-2">
                    <div class="col-6">
                        <SelectAuto id="animal" label="Quel animal ?" filter={animalNameFilter} onFilter={handleAnimalFilterInSelect} >
                            <option value="">- Choisissez -</option>
                            {
                                animalList && animalList.map((animal) => {
                                    return (
                                        <option key={animal.id} value={animal.id}>{animal.name}</option>
                                    )
                                })
                            }
                        </SelectAuto>
                    </div>
                    <div class="col-6">
                        <Select id="location" label="Sur quel terrain ?">
                            <option value="">- Choisissez -</option>
                            {
                                locations && locations.map((location) => {
                                    return (
                                        <option key={location.id} value={location.id}>{location.fullName}</option>
                                    )
                                })
                            }
                        </Select>
                    </div>
                    <div class="col-6">
                        <div class="form-floating  mb-2">
                            <input class="form-control" id="date" type="date" name="date" />
                            <label class="form-label" for="date">A quelle date ?</label>
                        </div>
                    </div>
                    <div class="col-6">
                        <input class="btn btn-primary" type="submit" label="Chercher" />
                    </div>
                </div>
            </form >
            <div class="ms-2">{resultCounter} résultat(s)</div>
            <Table id="whoWhereWhen"
                caption="Présence"
                columns={columns}
                selectable={false}
                cellFormat={cellFormat}
                pagination={false}
                data={result} />
        </>
    );
}